<div class="home"> <div class="container">

    <h1>Retail Training and Performance<br> Solutions </h1>
  <button class="bt1">Contact </button>
  <button class="bt2">Our Courses</button>
  <img src="../../../assets/Group 23097.png" alt="">
  
</div></div>
<div class="retail">
<div class="container">

  <h1>Retail Academy</h1>
  <div class="row">
  <div class="col-md-4">
    <div class="retail-box">
    <img src="../../../assets/Group 17700.png" alt="">
  <h4>Sales Enabling</h4>
  <p>These courses develop the set of,<br> and technical competencies <br> required to deliver high quality of <br> retail products and services.</p>
<img src="../../../assets/Group 23108.png" alt=""> 
</div></div>
  <div class="col-md-4">
    <div class="retail-box">
      <img src="../../../assets/Group 18874.png" alt=""> 
          <h4 class="s">Sales Enabling</h4>
    <p>These courses develop the set of,<br> and technical competencies <br> required to deliver high quality of <br> retail products and services.</p>
    <img src="../../../assets/Group 23108.png" alt=""> 
  </div></div>
  <div class="col-md-4">
    <div class="retail-box">
      <img src="../../../assets/Group 22293.png" alt="">
    <h4>Sales Enabling</h4>
    <p>These courses develop the set of, <br> and technical competencies <br> required to deliver high quality of <br> retail products and services.</p>
    <img src="../../../assets/Group 23108.png" alt=""> 
  </div></div>
 
  
</div>
</div>

</div>

<div class="container"><div class="customer">
<h1>Some of our Happy Customers</h1>
<img src="../../../assets/Group 9192.png" alt="">

</div></div>




<div class="Solutions">
  <div class="container">
    <h1>Solutions</h1>
    <div class="row">
    <div class="col-md-4">
      <div class="Solutions-box so1">
     <img  style="margin-top: -9px;" src="../../../assets/Group 16961.png" alt="">
     <h2>Team Building</h2>
     <p>We tailor team building activities <br> to meet your desired objectives. </p>
    </div></div>
    <div class="col-md-4">
      <div class="Solutions-box so2">
     <img style="margin-top: -24px;" src="../../../assets/Group 18155.png" alt="">
     <h2>E-Learning</h2>
     <p>We tailor team building activities <br> to meet your desired objectives. </p>
    </div></div>
    <div class="col-md-4">
      <div class="Solutions-box so3">
     <img src="../../../assets/Group 18322.png" alt="">
     <h2>Consulting</h2>
     <p>We tailor team building activities <br> to meet your desired objectives. </p>
    </div></div>
    <div class="col-md-6 so4">
      <div class="Solutions-box so4">
     <img style="margin-top: 20px;" src="../../../assets/Group 18077.png" alt="">
     <h2>Assessments</h2>
     <p>We build assessment tools and exams to help you periodically <br> assess the knowledge and skills of your team. </p>
    </div></div>
    <div class="col-md-6 so5">
      <div class="Solutions-box so5">
     <img src="../../../assets/Group 11864.png" alt="">
     <h2>Content Development</h2>
     <p>Our team of professional content writers and developers can fuel <br>
      your business with high quality content to support you marketing </p>
    </div></div>

  </div></div>
</div>
<div class="blog "><div class="container">
  <div class="head d-flex"><h1>Blog</h1>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="img-blog">
        <img src="../../../assets/tim-gouw-bwki71ap-y8-unsplash.png" alt="">
        <button>11 August 2019 </button>
      </div>
      <h2>Retail Staff Essential</h2>
      <p>Drive visibility into performance and work toward common <br> goals across the organization <br>
        with transparency and accountability—allowing you to you <br> always stay one step ahead of competition.
        </p>
    </div>
    <div class="col-md-6">
      <div class="img-blog">
        <img src="../../../assets/bench-accounting-C3V88BOoRoM-unsplash (1).png" alt="">
        <button>11 August 2019 </button>
      </div>
      <h2>Retail Staff Essential</h2>
      <p>Drive visibility into performance and work toward common <br> goals across the organization <br>
        with transparency and accountability—allowing you to you <br> always stay one step ahead of competition.
        </p>
    </div>
  </div>
 
  
</div>  </div>
<div class="container">
  <div class="bites">
    <div class="row">
    <div class="col-md-7">
      <h1>Bites</h1>
      <p>Retailo Bites deliver bites of learning to your team through their <br> mobiles and devices to help improve their competence and   <br>performance rapidly and engagingly.</p>
    <button>Get in Touch</button>

    </div>
  <div class="col-md-5">
    <div class="image">
<img src="../../../assets/Group 14548.png" alt="">
<img src="../../../assets/Group 10889.png" alt="">
    </div>
  </div>
  </div>
  </div>
</div>